import React, { Component } from "react";
import Slider from "@material-ui/core/Slider";
import Button from "@material-ui/core/Button";

class SettingsSheet extends React.PureComponent {
  state = {};

  toggleNotationDetails = () => {
    document.body.classList.toggle("detailed");
  };

  toggleDarkMode = () => {
    //change favicon color
    var link = document.querySelector("link[rel*='icon']");
    if (this.state.darkmode) {
      link.href = "/favicon.ico";
      this.setState({
        darkmode: false,
      });
    } else {
      link.href = "/favicon-dark.ico";
      this.setState({
        darkmode: true,
      });
    }
    // toggle dark-theme on the whole page
    document.body.classList.toggle("dark-theme");
  };

  render() {
    return (
      <div className="settings-content">
        {/* <button onClick={this.props.ToggleBottomSheet}>Open</button> */}
        <h1>Settings</h1>
        <div className="settings-row">
          <label>Volume</label>
          <Slider
            defaultValue={this.props.defaultVolume}
            onChange={this.props.OnVolumeChange}
            valueLabelDisplay="auto"
            aria-labelledby="continuous-slider"
            min={0}
            max={100}
            orientation="horizontal"
          />
        </div>
        <div className="settings-row">
          <label>Tempo</label>
          <Slider
            defaultValue={this.props.defaultTempo}
            onChange={this.props.OnTempoChange}
            aria-labelledby="continuous-slider"
            orientation="horizontal"
            min={40}
            max={160}
            // step={5}
            valueLabelDisplay="auto"
          />
        </div>
        <div className="settings-row">
          <label>Swing</label>
          <Slider
            defaultValue={this.props.defaultSwing}
            onChange={this.props.OnSwingChange}
            aria-labelledby="continuous-slider"
            orientation="horizontal"
            min={0}
            max={50}
            valueLabelDisplay="auto"
            // className={this.getSliderClasses()}
          />
        </div>
        <div className="settings-row">
          <label>Instrument</label>
          <div>
            <Button
              aria-label="Switch Instrument to Djembe "
              className="btn-settings"
              onClick={this.props.OnInstrumentChange}
            >
              <svg
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M21.2502 24.9031C21.2965 24.6688 21.502 24.5 21.7407 24.5H28.8519C29.0906 24.5 29.2961 24.6688 29.3424 24.9031L31.7127 36.9031C31.7417 37.0499 31.7035 37.2019 31.6085 37.3175C31.5135 37.433 31.3718 37.5 31.2222 37.5H19.3704C19.2208 37.5 19.0791 37.433 18.9841 37.3175C18.8891 37.2019 18.8509 37.0499 18.8799 36.9031L21.2502 24.9031ZM22.1516 25.5L19.9788 36.5H30.6138L28.441 25.5H22.1516Z"
                />
                <path d="M18.1852 11.5C17.98 11.5 17.7956 11.6254 17.7202 11.8163L16.535 14.8163C16.4742 14.9702 16.4935 15.1443 16.5866 15.2812C16.6797 15.4181 16.8345 15.5 17 15.5H33C33.1655 15.5 33.3203 15.4181 33.4134 15.2812C33.5065 15.1443 33.5259 14.9702 33.465 14.8163L32.2798 11.8163C32.2044 11.6254 32.02 11.5 31.8148 11.5H18.1852Z" />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M16.5994 14.7009C16.6937 14.5744 16.8423 14.5 17 14.5H33C33.1578 14.5 33.3063 14.5744 33.4006 14.7009C33.495 14.8273 33.5242 14.9908 33.4794 15.142L30.9407 23.7102C30.6262 24.7718 29.6509 25.5 28.5437 25.5H21.4563C20.3492 25.5 19.3739 24.7718 19.0593 23.7102L16.5206 15.142C16.4758 14.9908 16.505 14.8273 16.5994 14.7009ZM17.6696 15.5L20.0181 23.4261C20.2068 24.0631 20.792 24.5 21.4563 24.5H28.5437C29.208 24.5 29.7932 24.0631 29.9819 23.4261L32.3304 15.5H17.6696Z"
                />
              </svg>
            </Button>
            <Button
              aria-label="Switch Instrument to Cajon"
              className="btn-settings"
              onClick={this.props.OnInstrumentChange}
            >
              <svg
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M24 21.5C22.067 21.5 20.5 23.067 20.5 25C20.5 26.933 22.067 28.5 24 28.5C25.933 28.5 27.5 26.933 27.5 25C27.5 23.067 25.933 21.5 24 21.5Z" />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M15.5 15C15.5 14.7239 15.7239 14.5 16 14.5H32C32.2761 14.5 32.5 14.7239 32.5 15V35C32.5 35.2761 32.2761 35.5 32 35.5H31.5V37C31.5 37.2761 31.2761 37.5 31 37.5H29C28.7239 37.5 28.5 37.2761 28.5 37V35.5H19.5V37C19.5 37.2761 19.2761 37.5 19 37.5H17C16.7239 37.5 16.5 37.2761 16.5 37V35.5H16C15.7239 35.5 15.5 35.2761 15.5 35V15ZM31.5 34.5V15.5H16.5V34.5H31.5Z"
                />
              </svg>
            </Button>
          </div>
        </div>
        <div className="settings-row">
          <label>Theme</label>
          <div>
            <Button
              aria-label="Toggle Dark/Light Theme"
              className="btn-settings"
              onClick={() => {
                this.toggleDarkMode();
              }}
            >
              <svg
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M23.6436 13.5969V8.35543C23.6436 8.26114 23.6811 8.17075 23.7478 8.1041C23.8145 8.03745 23.9049 8 23.9992 8C24.0935 8 24.184 8.03745 24.2507 8.1041C24.3174 8.17075 24.3549 8.26114 24.3549 8.35543V13.5969C24.3549 13.6912 24.3174 13.7816 24.2507 13.8482C24.184 13.9149 24.0935 13.9523 23.9992 13.9523C23.9049 13.9523 23.8145 13.9149 23.7478 13.8482C23.6811 13.7816 23.6436 13.6912 23.6436 13.5969ZM34.8123 12.6864L31.1053 16.3927C31.0393 16.4597 31.0025 16.55 31.0029 16.6441C31.0034 16.7381 31.041 16.8282 31.1076 16.8946C31.1742 16.961 31.2643 16.9983 31.3584 16.9985C31.4525 16.9987 31.5428 16.9617 31.6096 16.8955L35.3147 13.1892C35.3782 13.1219 35.4129 13.0326 35.4116 12.9402C35.4103 12.8477 35.373 12.7594 35.3076 12.694C35.2422 12.6285 35.1539 12.5912 35.0615 12.5898C34.969 12.5883 34.8796 12.623 34.8123 12.6864ZM23.7832 16.5778C21.8523 16.6344 20.0196 17.4412 18.6738 18.8268C17.3281 20.2124 16.5754 22.0677 16.5754 23.9991C16.5681 24.9787 16.7548 25.9501 17.1247 26.8572C17.4946 27.7643 18.0404 28.5894 18.7307 29.2846C19.4209 29.9799 20.2419 30.5318 21.1464 30.9083C22.0509 31.2849 23.021 31.4788 24.0008 31.4788C24.9806 31.4788 25.9507 31.2849 26.8552 30.9083C27.7597 30.5318 28.5808 29.9799 29.271 29.2846C29.9612 28.5894 30.507 27.7643 30.8769 26.8572C31.2468 25.9501 31.4335 24.9787 31.4263 23.9991C31.4263 23.0058 31.2269 22.0226 30.8401 21.1077C30.4532 20.1928 29.8866 19.3649 29.1739 18.6729C28.4613 17.9809 27.6169 17.4389 26.691 17.079C25.765 16.7191 24.7762 16.5487 23.7832 16.5778ZM23.9999 17.2866V30.7136C22.22 30.7121 20.5135 30.0042 19.2555 28.7453C17.9974 27.4865 17.2908 25.7797 17.2908 24.0001C17.2908 22.2205 17.9974 20.5138 19.2555 19.2549C20.5135 17.9961 22.22 17.288 23.9999 17.2866ZM34.4058 23.6445H39.6484C39.7421 23.6454 39.8317 23.6833 39.8976 23.7499C39.9636 23.8165 40.0006 23.9064 40.0006 24.0001C40.0006 24.0938 39.9636 24.1837 39.8976 24.2503C39.8317 24.3169 39.7421 24.3547 39.6484 24.3556H34.4058C34.3121 24.3547 34.2226 24.3169 34.1566 24.2503C34.0907 24.1837 34.0537 24.0938 34.0537 24.0001C34.0537 23.9064 34.0907 23.8165 34.1566 23.7499C34.2226 23.6833 34.3121 23.6454 34.4058 23.6445ZM35.3144 34.8109L31.6093 31.1046C31.5424 31.0386 31.4522 31.0017 31.3582 31.002C31.2642 31.0022 31.1741 31.0395 31.1076 31.1059C31.041 31.1722 31.0034 31.2622 31.0029 31.3561C31.0025 31.4501 31.0391 31.5405 31.105 31.6075L34.8119 35.3137C34.8793 35.3769 34.9686 35.4114 35.061 35.4099C35.1534 35.4084 35.2415 35.3711 35.3068 35.3057C35.3721 35.2404 35.4094 35.1522 35.4108 35.0599C35.4122 34.9675 35.3776 34.8782 35.3144 34.8109ZM24.3549 34.4032V39.6445C24.3549 39.7388 24.3174 39.8293 24.2507 39.896C24.184 39.9626 24.0935 40 23.9992 40C23.9049 40 23.8145 39.9626 23.7478 39.896C23.6811 39.8293 23.6436 39.7388 23.6436 39.6445V34.4032C23.6436 34.3089 23.6811 34.2185 23.7478 34.1518C23.8145 34.0852 23.9049 34.0477 23.9992 34.0477C24.0935 34.0477 24.184 34.0852 24.2507 34.1518C24.3174 34.2185 24.3549 34.3089 24.3549 34.4032ZM13.1878 35.3137L16.8951 31.6075C16.9585 31.5402 16.9932 31.4509 16.9918 31.3584C16.9904 31.266 16.9531 31.1778 16.8878 31.1124C16.8225 31.047 16.7342 31.0097 16.6418 31.0082C16.5494 31.0068 16.46 31.0413 16.3927 31.1046L12.6854 34.8109C12.6221 34.8782 12.5875 34.9675 12.5889 35.0599C12.5903 35.1522 12.6276 35.2404 12.6929 35.3057C12.7582 35.3711 12.8464 35.4084 12.9387 35.4099C13.0311 35.4114 13.1204 35.3769 13.1878 35.3137ZM13.5947 24.3556H8.35213C8.25842 24.3547 8.16886 24.3169 8.10293 24.2503C8.03699 24.1837 8 24.0938 8 24.0001C8 23.9064 8.03699 23.8165 8.10293 23.7499C8.16886 23.6833 8.25842 23.6454 8.35213 23.6445H13.5947C13.6884 23.6454 13.778 23.6833 13.8439 23.7499C13.9099 23.8165 13.9468 23.9064 13.9468 24.0001C13.9468 24.0938 13.9099 24.1837 13.8439 24.2503C13.778 24.3169 13.6884 24.3547 13.5947 24.3556ZM12.6858 13.1892L16.3931 16.8955C16.4605 16.9589 16.5499 16.9935 16.6423 16.9921C16.7348 16.9907 16.8231 16.9534 16.8885 16.8879C16.9539 16.8225 16.9912 16.7342 16.9925 16.6417C16.9938 16.5493 16.959 16.4599 16.8956 16.3927L13.1883 12.6864C13.1209 12.623 13.0315 12.5884 12.939 12.5898C12.8466 12.5912 12.7583 12.6285 12.6929 12.694C12.6275 12.7594 12.5902 12.8477 12.5889 12.9402C12.5876 13.0326 12.6223 13.1219 12.6858 13.1892Z" />
              </svg>
            </Button>
          </div>
        </div>
        <div className="settings-row">
          <label>Notation</label>
          <div>
            <Button
              aria-label="Toggle number notation"
              className="btn-settings"
              onClick={() => {
                this.toggleNotationDetails();
              }}
            >
              <svg
                width="48"
                height="48"
                viewBox="0 0 48 48"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M26.675 21.7344H20.8918V20.7467C21.1754 20.4977 21.4611 20.253 21.7429 20.0117C23.4941 18.5119 25.0924 17.1433 25.0924 15.6774C25.0924 14.773 24.6997 14.1543 23.6882 14.1543C22.7362 14.1543 22.2245 14.8206 22.1888 15.7964H20.8799C20.9275 13.9163 22.1412 13 23.6763 13C25.4375 13 26.437 14.0591 26.437 15.6179C26.437 17.4687 24.7831 18.9336 23.4373 20.1256C23.2515 20.2902 23.0717 20.4495 22.9028 20.6039H26.675V21.7344ZM15.9721 28.6785H17.1741V21.0587H15V22.1458H15.9721V28.6785ZM27.4475 27.1034H29.0325C29.1325 26.3751 29.6608 25.6897 30.8032 25.6897C31.917 25.6897 32.5025 26.2894 32.5025 27.189C32.5025 28.3029 31.6028 28.7312 30.132 28.7455H29.7465V30.0878H30.1178C31.817 30.0878 32.7024 30.559 32.7024 31.9299C32.7024 32.9009 32.1026 33.6434 30.8889 33.6434C29.6608 33.6434 28.9468 32.9009 28.8754 31.9299H27.3047C27.4046 33.9719 28.9326 35 30.9031 35C33.0736 35 34.2446 33.7434 34.2446 32.0869C34.2446 30.6447 33.5449 29.7451 32.4596 29.4167V29.3595C33.2736 29.0882 34.0589 28.2457 34.0589 27.0034C34.0589 25.4898 32.9308 24.2903 30.8603 24.2903C28.9611 24.2903 27.5617 25.3041 27.4475 27.1034Z" />
              </svg>
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default SettingsSheet;
